import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AssessmentItemQuestionCreateInput } from '../generated/globalTypes';
import { createAssessmentItemQuestionMutation, createAssessmentItemQuestionMutationVariables } from '../generated/createAssessmentItemQuestionMutation';
import { assessmentItemQuestionFieldsFragment } from '../models/AssessmentItemQuestion';

/**
 * Get a callback to create a AssessmentItemQuestion in the store.
 */
export function useCreateAssessmentItemQuestionCallback(): [(model: AssessmentItemQuestionCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createAssessmentItemQuestionMutation, createAssessmentItemQuestionMutationVariables>(
        gql`
            mutation createAssessmentItemQuestionMutation ($model: AssessmentItemQuestionCreateInput!) {
                createAssessmentItemQuestion(model: $model) {
                    ...assessmentItemQuestionFields
                }
            }

            ${assessmentItemQuestionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: AssessmentItemQuestionCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
